import { render } from "./Dashboard.vue?vue&type=template&id=4466eaff&scoped=true&ts=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=4466eaff&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4466eaff"]])

export default __exports__